/**
 * @overview 教室管理
 * @author jzhu
 * @date 2020-5-26
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool

class Classroom extends WizContainer {

    componentName = 'Classroom'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _handleTrainCenterList(nextProps, nextState, key) {
        let o = nextProps[key]
        if (o.success) {
            let f = (l) => {
                l && l.length && l.forEach(d => {
                    d.code = d.id
                    d.codeName = d.name
                })
            }
            f(o.data)
            return true
        } else {
            wizNotice.error(o.msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig,
            apiDataFormat: {
                trainCenterList: this._handleTrainCenterList
            },
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(Classroom)
